import React from "react";
import { Route, Redirect } from "react-router-dom";
import BankAdminLayout from "../layouts/BankAdminLayout";
import _authService from "modules/AuthService.js";
import NetworkDetector from "../HOC/NetworkDetector";

const BankAdminRoute = ({ component: Component, layout: Layout, role: role, menuId: menuId, ...rest }) => (
  <Route key={Math.floor((Math.random() * 9999999) + 1)} {...rest} render={props => (
    //Also check role
    _authService.isBankAdminAuthenticated()
      ?
      <BankAdminLayout componentName={menuId}>
        <Component {...props} />
      </BankAdminLayout>
      :
      <Redirect to={{
        pathname: '/bankadmin/login'
      }} />
  )} />

  // <Route {...rest} render={props => (
  //     <PrivateLayout>
  //       <Component {...props} />
  //     </PrivateLayout>
  //   )} />
)

export default NetworkDetector(BankAdminRoute)